import { TextArea } from "@faire/web--source/slate/Input/TextArea";
import { getSpacing } from "@faire/web--source/slate/spacing";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import { Typography } from "@faire/web--source/slate/Typography";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import React from "react";
import styled from "styled-components";

import { CONTACT_CARDS_COMBINED_WIDTH } from "../../consts";

interface IProps {
  visibleWhen: boolean;
  value: string;
  onChange: (value: string) => void;
}

const CHARACTERS_LIMIT = 500;

export const OpenReasonTextArea: React.FC<IProps> = ({
  visibleWhen,
  value,
  onChange,
}) => {
  if (!visibleWhen) {
    return null;
  }

  return (
    <Wrapper>
      <TextAreaPurposeMessage />
      <TextArea
        value={value}
        onChange={(event) => onChange(event.target.value)}
        maxLength={CHARACTERS_LIMIT}
        data-test-id="csat-open-text-area"
      />
    </Wrapper>
  );
};

const TextAreaPurposeMessage: React.FC = () => {
  return (
    <Typography
      variant="labelSansRegular"
      style={{ marginBottom: getSpacing("1x") }}
    >
      <StrictLocalMsg
        defaultMessage="Share feedback about your support experience here. For all other issues, you can contact us using the options above."
        description={{
          text: "Clarifying message shown to users when they are asked to provide feedback about their support experience.",
        }}
      />
    </Typography>
  );
};

const Wrapper = styled.div`
  margin-top: ${getSpacing("2x")};
  width: 100%;

  ${responsiveMediaQueries.tabletAndAbove} {
    width: ${CONTACT_CARDS_COMBINED_WIDTH};
  }

  textarea {
    min-height: 150px;
  }
`;
